import React from 'react';

interface Props {
    tla:string;
    jwtToken:string;
}
/**
 * Widget for Chatbot
 * (Only include relating js/css file when enabled)
 */
export default class Chatbot extends React.Component<Props, {}> {
    render() {
        return (
            <React.Fragment>
                <div id="bot" ref="bot"></div>                
            </React.Fragment>
        )
    }

    static scriptObservers = {};

    componentDidMount() {
        this.createScript();
    }

    createScript() {
        let urlScript = '/paybotus/www/js/paybotus-widget.js';
        let urlCss = '/paybotus/www/css/paybotus-widget.css';
        const script = document.createElement('script');
        const link = document.createElement('link')

        script.src = urlScript;
        script.async = false;
        link.rel = 'stylesheet';
        link.href = urlCss

        script.onload = () => {
            // @ts-ignore
            window.payBotUs.render({
                selector: '#bot',
                tla: `${this.props.tla}`,
                jwt: `${this.props.jwtToken}`
            });
        };

        document.body.appendChild(script);
        document.body.appendChild(link);
    }
}